module.exports = __webpack_public_path__ + "img/3D.5e215e1e.png";